import { render } from "./ExtraChargeIndex.vue?vue&type=template&id=0e3fb2c3"
import script from "./ExtraChargeIndex.vue?vue&type=script&lang=js"
export * from "./ExtraChargeIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__